export const getHoursSinceTOD = (time: string | undefined) => {
    if (!time) return undefined;
    const tod = new Date(time);
    const diffMs = Date.now() - tod.getTime();
    const diffHours = diffMs / 1000 / 60 / 60;
    return Math.ceil(diffHours);
};
